import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
const About = () => {
  return (
    <div>
      <Helmet>
    <meta name="google-site-verification" content="ebvLr84CVTSpjtrusz7g7RB21J384B2SJOGrau8jl04" />
        <title>Aplikasi toko penjuan kasir vpos web app</title>
        <meta
          content="Aplikasi toko penjuan kasir vpos web app"
          name="twitter:title"
        />
        <meta
          content="Aplikasi toko penjuan kasir vpos web app"
          name="facebook:title"
        />
        <meta
          content="Aplikasi toko penjuan kasir vpos web app"
          property="og:title"
        />
        <meta
          content="Aplikasi toko penjuan kasir vpos web app"
          property="og:site_name"
        />
        <meta
          content="Mesin kasir online vpos mudah digunakan dan dilengkapi dengan laporan stok, pendapatan omset,plus website modern terbaru all in one pada vpos web app."
          property="og:description"
        />
        <meta
          name="description"
          content="Mesin kasir online vpos mudah digunakan dan dilengkapi dengan laporan stok, pendapatan omset,plus website modern terbaru all in one pada vpos web app."
        />
        <meta
          content="Mesin kasir online vpos mudah digunakan dan dilengkapi dengan laporan stok, pendapatan omset,plus website modern terbaru all in one pada vpos web app."
          property="facebook:description"
        />
        <meta
          content="Mesin kasir online vpos mudah digunakan dan dilengkapi dengan laporan stok, pendapatan omset,plus website modern terbaru all in one pada vpos web app."
          name="twitter:description"
        />
        <meta
          content="https://1.bp.blogspot.com/-oolLYoq-j5Q/X93ym6YAD8I/AAAAAAAALus/NZ7SFbMNI543KZaqFx129dX0ST4MBQAQACLcBGAsYHQ/w1200-h630-p-k-no-nu/TOUCHSCREEN3.png"
          property="og:image"
        />
        <meta content="https://axcora.com/getaxcoracms" property="og:author" />

        <meta content="website" property="og:type" />
        <meta
          content="https://www.facebook.com/mesinkasircomplete"
          property="facebook:author"
        />
        <meta
          content="https://res.cloudinary.com/hockeycorp/image/upload/v1568369085/touchscreen_yonrpa.jpg"
          name="facebook:image"
        />
        <meta content="summary_large_image" name="twitter:card" />
        <meta
          content="https://twitter.com/hockeycomp"
          property="twitter:author"
        />
        <meta content="@hockeycomp" name="twitter:site" />
        <meta
          content="https://res.cloudinary.com/hockeycorp/image/upload/v1568369085/touchscreen_yonrpa.jpg"
          name="twitter:image"
        />
        <meta content="index, follow" name="robots" />
      </Helmet>
      <div className="animate__animated animate__bounceIn">
        <h1>
          <a href="/">Point Of Sale Web App</a>
        </h1>
        <h3>Mesin kasir online aplikasi toko website application</h3>

        <p>
          Solusi digital online untuk usaha dan toko modern dengan aplikasi toko
          penjualan kasir include laporan detail plus website untuk menunjang
          usaha dan bisnis bersama vpos web app.
        </p>

        <img
          className="img-fluid float-end"
          alt="mesin kasir online"
          src="https://1.bp.blogspot.com/-KTTGh8Ilg-s/XtAtR0ZNY-I/AAAAAAAAJsI/-9uA7xCzO0guSxbAGr2P5_r-avgRZT_igCK4BGAsYHg/point%2Bof%2Bsale%2Bweb%2Bapp.jpg"
        />
        <p>
          Dukungan penuh installasi via online clouds menyempurnakan dalam akses
          mobile pos apps untuk kebutuhan dan akses serta bekerja via smartphone
          android dan iphone.
        </p>

        <img
          className="img-fluid float-start"
          alt="mesin kasir online"
          src="https://1.bp.blogspot.com/-mKimFWSzLgA/XtAtQe-CGmI/AAAAAAAAJsA/CTRocaxRDEQCE2YclS0l-5k-wABUipiOwCK4BGAsYHg/mesin%2Bkasir%2Bonline%2Bnew%2Bvpos%2Bweb%2Bapp.jpg"
        />
        <p>
          Multi device solutions menjadikan kemudahan dalam kebutuhan akses dari
          berbagai device dalam bekerja dengan vpos web apps ini untuk digunakan
          secara bersamaan dengan karyawan dan staff.
        </p>

        <img
          className="img-fluid float-end"
          alt="mesin kasir online"
          src="https://1.bp.blogspot.com/-z_Ggg-6ToVQ/XtAtREsij2I/AAAAAAAAJsE/twJyXPG4Tng3S1iHC1pmH7BmHOStNOE_QCK4BGAsYHg/mesin%2Bkasir%2Bonline%2Bvpos.jpg"
        />
        <p>
          Mulai gunakan Vpos web app dalam kebutuhan terbaik untuk mesin kasir
          online point of sale web apps include website untuk all in one full
          online. Saat nya revolusi digital usaha anda dimulai bersama web apps.
        </p>
        <div className="text-center">
          <Link to="/pos" className="btn btn-primary rounded">
            Get Started Now
          </Link>
        </div>
      </div>
    </div>
  );
};
export default About;
